// extracted by mini-css-extract-plugin
module.exports = {"hide":"Review_hide__pcRk1","colorD20":"Review_colorD20__2FYv7"};